import { EismItem } from '@src/components';
import { useGetCurrentEsimsQuery } from '@src/services/esim/esimApiSlice';
import { ExploreESimBanner } from './ExploreESimBanner';
import { StyledCarousel } from './styles';
import { WidgetSkeleton } from '@src/components/Loading/WidgetSkeleton';
interface ActiveESimsProps {
  onEsimsDetected?: () => void;
}

export function ActiveESims({ onEsimsDetected }: Readonly<ActiveESimsProps>) {
  const { data: esims, isLoading } = useGetCurrentEsimsQuery();

  if (isLoading) {
    return <WidgetSkeleton className='h-full' />;
  }

  if (esims && esims.length > 0 && onEsimsDetected) {
    onEsimsDetected();
  }

  return (
    <div className='w-full h-full [&_.ant-carousel]:!h-full'>
      {(esims?.length || 0) > 0 ? (
        <StyledCarousel autoplay dots={(esims?.length || 0) > 1}>
          {esims?.map((esim) => (
            <EismItem mode='dashboard' key={esim.esimId} esim={esim} />
          ))}
        </StyledCarousel>
      ) : (
        <ExploreESimBanner />
      )}
    </div>
  );
}
